import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../../utils/api';

export const postAdminHideColumnsAPI = createApi("PostAdminHideColumns","POST");

const PostAdminHideColumns = createSlice({
  name: 'PostAdminHideColumns',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(postAdminHideColumnsAPI.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(postAdminHideColumnsAPI.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(postAdminHideColumnsAPI.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default PostAdminHideColumns.reducer;